var LOG_LEVEL;

(function (LOG_LEVEL) {
  LOG_LEVEL["DEBUG"] = "debug";
  LOG_LEVEL["INFO"] = "info";
  LOG_LEVEL["WARN"] = "warn";
  LOG_LEVEL["ERROR"] = "error";
})(LOG_LEVEL || (LOG_LEVEL = {}));

const PROTOCOL = {
  FILE: 'file:'
};
export { LOG_LEVEL, PROTOCOL };